import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '@shared/shared.module';
import { ProgramHomeComponent } from './program-home.component';
import { ProgramOverviewComponent } from '../program-overview/program-overview.component';
import { EmbedDialogModule } from '@shared/components/embed-dialog/embed-dialog.module';
import { DownloadDialogModule } from '@shared/components/download-dialog/download-dialog.module';
import { CourseEditDialogModule } from '@app/main/apps/course-edit-dialog/course-edit-dialog.module';
import { TemplatePickerDialogModule } from '@shared/components/template-picker-dialog/template-picker-dialog.module';
import { SimulationListComponent } from '../program-overview/simulation-list/simulation-list.component';
import { ProgramReportingModule } from '../program-reporting/program-reporting.module';
import { ProgramSettingsComponent } from '../program-settings/program-settings.component';
import { ProgramParticipantsComponent } from '../program-participants/program-participants.component';

@NgModule({
  declarations: [
    ProgramHomeComponent,
    ProgramOverviewComponent,
    SimulationListComponent,
    ProgramSettingsComponent,
    ProgramParticipantsComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ProgramReportingModule,
    EmbedDialogModule,
    DownloadDialogModule,
    CourseEditDialogModule,
    TemplatePickerDialogModule,
    DragDropModule
  ]
})
export class ProgramHomeModule { }
